// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hotel-row {
  display: grid;
  grid-template-columns: 4vw 4vw auto;
  gap: 1vw;
}

.hotel-panel {
  display: grid;
  align-self: start;
  gap: 1.5vw;
  grid-template-rows: repeat(6, auto);
  overflow: hidden;
}

.hotel-avatardiv {
  border: solid 0.15vw #1a6a7c;
  display: grid;
  place-items: center;
  font-size: 3vw;
  text-align: center;
}

.hotel-input {
  height: 4vw;
  font-size: 2vw;
  text-align: center;
}

.hotel-buttonCheck {
  display: flex;
  gap: 0.5vw;
  padding: 0.4vw 0.75vw;
  justify-content: space-evenly;
  border-radius: 0.9vw;
  width: max-content;
  height: max-content;
  cursor: pointer;
  color: white;
  place-self: center;
  font-size: 1.8vw;
  white-space: nowrap;
  background-color: #1a6a7c;
}
.hotel-logoRun {
   height: 2.1vw;
  place-self: center;
}
.hotel-control {
  place-items: center;
  display: grid;
  grid-template-rows: 1fr auto;
  gap: 1vh;
  min-height: 100%;
}
.hotel-input:focus {
  background-color: #98d5cc;
}
.hotel-callImg {
  width: 100%;
  height: 100%;
}

.hotel-call {
  height: 4vw;
}

.hotel-avatar {
  width: 3.5vw;
  height: 3.5vw;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Stevehotel/styles/HotelRenderButton.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mCAAmC;EACnC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,UAAU;EACV,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;GACG,aAAa;EACd,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;AACf","sourcesContent":[".hotel-row {\n  display: grid;\n  grid-template-columns: 4vw 4vw auto;\n  gap: 1vw;\n}\n\n.hotel-panel {\n  display: grid;\n  align-self: start;\n  gap: 1.5vw;\n  grid-template-rows: repeat(6, auto);\n  overflow: hidden;\n}\n\n.hotel-avatardiv {\n  border: solid 0.15vw #1a6a7c;\n  display: grid;\n  place-items: center;\n  font-size: 3vw;\n  text-align: center;\n}\n\n.hotel-input {\n  height: 4vw;\n  font-size: 2vw;\n  text-align: center;\n}\n\n.hotel-buttonCheck {\n  display: flex;\n  gap: 0.5vw;\n  padding: 0.4vw 0.75vw;\n  justify-content: space-evenly;\n  border-radius: 0.9vw;\n  width: max-content;\n  height: max-content;\n  cursor: pointer;\n  color: white;\n  place-self: center;\n  font-size: 1.8vw;\n  white-space: nowrap;\n  background-color: #1a6a7c;\n}\n.hotel-logoRun {\n   height: 2.1vw;\n  place-self: center;\n}\n.hotel-control {\n  place-items: center;\n  display: grid;\n  grid-template-rows: 1fr auto;\n  gap: 1vh;\n  min-height: 100%;\n}\n.hotel-input:focus {\n  background-color: #98d5cc;\n}\n.hotel-callImg {\n  width: 100%;\n  height: 100%;\n}\n\n.hotel-call {\n  height: 4vw;\n}\n\n.hotel-avatar {\n  width: 3.5vw;\n  height: 3.5vw;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
